import { useState, useEffect } from "react";
import { Row, Col, Typography, Button } from "antd";
import { Colors } from "theme";
import { useHistory } from "react-router-dom";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";
import Can from "../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
const { Title } = Typography;
export default function PageHeader({ data }) {
  const history = useHistory();

  const [IsProductCatChanged, setIsProductCatChanged] = useState(false);



  useEffect(() => {
    if (data) {
      if (localStorage.getItem("Primary_Text")) {
        if (
          localStorage.getItem("Primary_Text") ===
          data?.secondary_category?.name
        ) {
          setIsProductCatChanged(false);
        } else {
          setIsProductCatChanged(true);
        }
      } else {
        setIsProductCatChanged(false);
      }
    }
  }, [data]);

  const gotoCategoryNew =
    data?.secondary_category?.name.length > 14
      ? data?.secondary_category?.name.substr(0, 12) + ".."
      : data?.secondary_category?.name;

  const gotoCategoryOld = localStorage.getItem("Primary_Text")
    ? localStorage.getItem("Primary_Text").length > 14
      ? localStorage.getItem("Primary_Text").substr(0, 12) + ".."
      : localStorage.getItem("Primary_Text")
    : gotoCategoryNew;

  const handleCategoryClickOld = () => {
    history.push(localStorage.getItem("Cat_URL"));

    window.location.reload();
  };

  const handleCategoryClickNew = () => {
    history.push(
      `/categorywise-products/${data?.secondary_category?.name}/${data?.secondary_category?.id}`
    );
    window.location.reload();
  };

  return (
    <>
      <Row className="product-details-header" align="middle">
        <Col offset={2} span={10}>
          <Row>
            <Col>
              <Title level={3} className="title">
                {" "}
                Product saved successfully!{" "}
              </Title>
              {/* <Title level={5}>
                The completion score is {data?.completion_score}%
              </Title> */}
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Row>
            <Col span={12}>
              <Button
                type="primary"
                size="large"
                style={{ width: "90%", height: 46 }}
                onClick={() => {
                  
                    localStorage.getItem("Primary_Text")
                      ? handleCategoryClickOld()
                      : handleCategoryClickNew();
                  
                  gaEvent(
                    GA.EVENT.CLICK,
                    GA.CATEGORY.ADD_PRODUCT,
                    GA.DESCRIPTION.PRODUCT_DETAILS_GO_TO_BUTTON,
                    data?.product_id
                  );
                }}
              >
                Go to {gotoCategoryOld}
              </Button>
            </Col>

            {IsProductCatChanged ? (
              <Col span={12}>
                <Button
                  type="primary"
                  size="large"
                  style={{
                    color: Colors.white,
                    background: "#363E3D",
                    border: 0,
                    width: "90%",
                    height: 46,
                  }}
                  onClick={() => {
                    handleCategoryClickNew();
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.ADD_PRODUCT,
                      GA.DESCRIPTION.PRODUCT_DETAILS_GO_TO_BUTTON,
                      data?.product_id
                    );
                  }}
                >
                  Go to {gotoCategoryNew}
                </Button>
              </Col>
            ) : null}

            {!IsProductCatChanged ? (
              

            
       <Can
       I={PERMISSIONS.create_products.slug}
       a={PERMISSIONS.create_products.permissionType}
     >
       {(allowed) => (
        <Col span={10}>
        <Button
          type="primary"
          size="large"
          style={{
            color: Colors.white,
            background: "#363E3D",
            border: 0,
            width: "90%",
            height: 46,
          }}
          onClick={() => {
            history.push("/add-product");
            gaEvent(
              GA.EVENT.CLICK,
              GA.CATEGORY.ADD_PRODUCT,
              GA.DESCRIPTION.PRODUCT_DETAILS_ADD_ANOTHER_PRODUCT_BUTTON,
              data?.product_id
            );
          }}
        >
          Add Products
        </Button>
        </Col>
       )}
     </Can>
  
          
            ) : null}
          </Row>
        </Col>
      </Row>
    </>
  );
}
